import { render } from "./FuturesProfitActionGraphWidgetParams.vue?vue&type=template&id=13097842"
import script from "./FuturesProfitActionGraphWidgetParams.vue?vue&type=script&lang=js"
export * from "./FuturesProfitActionGraphWidgetParams.vue?vue&type=script&lang=js"
script.render = render

export default script